<template>
  <div class="crud-evento">
    <div class="page-header">
      <div>
        <h1 class="page-title-wrap">Evento</h1>
        <p class="page-sub">Datos del evento activo</p>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="estado-centro">
      <span class="spinner-border spinner-border-sm text-warning me-2"></span>
      Cargando evento...
    </div>

    <!-- Sin evento -->
    <div v-else-if="!evento" class="card-vacio">
      <i class="bi bi-calendar-x" style="font-size: 2rem; opacity: 0.3"></i>
      <p>No hay evento activo registrado.</p>
    </div>

    <!-- Contenido del evento -->
    <div v-else class="evento-layout">
      <!-- ── Cabecera ── -->
      <div class="evento-header-card">
        <div class="evento-header-left">
          <span class="badge-activo">
            <span class="badge-dot"></span>
            Activo
          </span>
          <p class="evento-nombre">{{ evento.nombre }}</p>
          <p class="evento-ubicacion">
            <i class="bi bi-geo-alt-fill"></i>
            {{ evento.ubicacion }}
          </p>
        </div>
        <button class="btn-primary" @click="abrirEditar">
          <i class="bi bi-pencil-fill"></i> Editar evento
        </button>
      </div>

      <!-- ── Fila de cards ── -->
      <div class="cards-row">
        <!-- Card: Fecha y hora del evento -->
        <div class="info-card">
          <div class="card-section-title">
            <i class="bi bi-calendar3"></i>
            Fecha y hora del evento
          </div>
          <div class="card-fields">
            <div class="field-item">
              <span class="field-label">Fecha</span>
              <span class="field-val accent">{{ formatFecha(evento.fecha_evento) }}</span>
            </div>
            <div class="field-divider"></div>
            <div class="field-item">
              <span class="field-label">Hora inicio</span>
              <span class="field-val">{{ evento.hora_inicio || "—" }}</span>
            </div>
            <div class="field-divider"></div>
            <div class="field-item">
              <span class="field-label">Hora fin</span>
              <span class="field-val">{{ evento.hora_fin || "—" }}</span>
            </div>
          </div>
        </div>

        <!-- Card: Fecha y hora de pesaje -->
        <div class="info-card">
          <div class="card-section-title">
            <i class="bi bi-speedometer2"></i>
            Fecha y hora de pesaje
          </div>
          <div class="card-fields">
            <div class="field-item">
              <span class="field-label">Fecha</span>
              <span class="field-val accent">
                {{ evento.fecha_pesaje ? formatFecha(evento.fecha_pesaje) : "—" }}
              </span>
            </div>
            <div class="field-divider"></div>
            <div class="field-item">
              <span class="field-label">Hora</span>
              <span class="field-val">{{ evento.hora_pesaje || "—" }}</span>
            </div>
          </div>
        </div>

        <!-- Card: Cupo -->
        <div class="info-card">
          <div class="card-section-title">
            <i class="bi bi-people-fill"></i>
            Cupo
          </div>
          <div class="cupo-card-body">
            <div class="cupo-pct-big">{{ evento.porcentaje_cupo }}<span>%</span></div>
            <div class="cupo-label-sub">Ocupado</div>
            <div class="cupo-track">
              <div
                class="cupo-fill"
                :style="{ width: evento.porcentaje_cupo + '%' }"
                :class="cupoClass(evento.porcentaje_cupo)"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Fila inferior: Video + Descripción ── -->
      <div class="bottom-row">
        <!-- Card: Video promocional -->
        <div class="info-card video-card">
          <div class="card-section-title">
            <i class="bi bi-play-circle-fill"></i>
            Video promocional
          </div>
          <div v-if="youtubeEmbedUrl" class="iframe-wrap">
            <iframe
              :src="youtubeEmbedUrl"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div v-else class="video-vacio">
            <i class="bi bi-youtube"></i>
            <span>Sin video asignado</span>
          </div>
          <div class="video-url-row">
            <i class="bi bi-link-45deg"></i>
            <span class="video-url-text">{{ evento.video_promocional_url || "—" }}</span>
          </div>
        </div>

        <!-- Card: Descripción -->
        <div class="info-card desc-card">
          <div class="card-section-title">
            <i class="bi bi-file-text-fill"></i>
            Descripción
          </div>
          <p class="desc-texto">
            {{ evento.descripcion || "Sin descripción registrada." }}
          </p>
        </div>
      </div>
    </div>

    <!-- ── MODAL EDITAR ── -->
    <div v-if="modalEditar" class="modal-overlay" @click.self="cerrarEditar">
      <div class="modal-panel">
        <div class="modal-header">
          <h2 class="modal-titulo">Editar evento</h2>
          <button class="btn-icon" @click="cerrarEditar">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="form-grid" v-if="eventoEditar">
          <!-- Nombre -->
          <div class="form-group col-span-2">
            <label>Nombre del evento *</label>
            <input v-model="eventoEditar.nombre" class="input-form" />
          </div>

          <!-- Separador sección evento -->
          <div class="form-section-label col-span-2">
            <i class="bi bi-calendar3"></i> Fecha y hora del evento
          </div>

          <div class="form-group">
            <label>Fecha del evento *</label>
            <input v-model="eventoEditar.fecha_evento" type="date" class="input-form" />
          </div>
          <div class="form-group">
            <label>Ubicación *</label>
            <input v-model="eventoEditar.ubicacion" class="input-form" />
          </div>
          <div class="form-group">
            <label>Hora inicio *</label>
            <input v-model="eventoEditar.hora_inicio" type="time" class="input-form" />
          </div>
          <div class="form-group">
            <label>Hora fin</label>
            <input v-model="eventoEditar.hora_fin" type="time" class="input-form" />
          </div>

          <!-- Separador sección pesaje -->
          <div class="form-section-label col-span-2">
            <i class="bi bi-speedometer2"></i> Fecha y hora de pesaje
          </div>

          <div class="form-group">
            <label>Fecha de pesaje</label>
            <input v-model="eventoEditar.fecha_pesaje" type="date" class="input-form" />
          </div>
          <div class="form-group">
            <label>Hora de pesaje</label>
            <input v-model="eventoEditar.hora_pesaje" type="time" class="input-form" />
          </div>

          <!-- Separador multimedia -->
          <div class="form-section-label col-span-2">
            <i class="bi bi-play-circle-fill"></i> Video y descripción
          </div>

          <div class="form-group col-span-2">
            <label>Video promocional (YouTube URL)</label>
            <input
              v-model="eventoEditar.video_promocional_url"
              type="url"
              class="input-form"
              placeholder="https://www.youtube.com/watch?v=..."
            />
          </div>
          <div class="form-group col-span-2">
            <label>Descripción</label>
            <textarea
              v-model="eventoEditar.descripcion"
              class="input-form"
              rows="3"
            ></textarea>
          </div>

          <!-- Cupo -->
          <div class="form-section-label col-span-2">
            <i class="bi bi-people-fill"></i> Cupo
          </div>
          <div class="form-group">
            <label>% Cupo ocupado</label>
            <input
              v-model="eventoEditar.porcentaje_cupo"
              type="number"
              min="0"
              max="100"
              class="input-form"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-secondary" @click="cerrarEditar">Cancelar</button>
          <button class="btn-primary" :disabled="guardando" @click="guardar">
            <span v-if="guardando">
              <span class="spinner-border spinner-border-sm"></span>
            </span>
            <span v-else><i class="bi bi-floppy-fill"></i> Guardar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Swal from "sweetalert2";
import { getEventoActivoDashboard, editarEventoDashboard } from "@/utils/api_dashboard";

const evento = ref(null);
const cargando = ref(false);
const modalEditar = ref(false);
const eventoEditar = ref(null);
const guardando = ref(false);

/** Convierte URL de YouTube (watch o youtu.be) a embed */
const youtubeEmbedUrl = computed(() => {
  const url = evento.value?.video_promocional_url;
  if (!url) return null;
  const watchMatch = url.match(/[?&]v=([^&#]+)/);
  const shortMatch = url.match(/youtu\.be\/([^?&#]+)/);
  const embedMatch = url.match(/youtube\.com\/embed\/([^?&#]+)/);
  const id = (watchMatch || shortMatch || embedMatch)?.[1];
  return id ? `https://www.youtube.com/embed/${id}` : null;
});

function cupoClass(pct) {
  if (pct >= 90) return "cupo-rojo";
  if (pct >= 60) return "cupo-amarillo";
  return "cupo-verde";
}

async function cargar() {
  cargando.value = true;
  try {
    evento.value = await getEventoActivoDashboard();
  } catch {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar el evento.",
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    cargando.value = false;
  }
}

function abrirEditar() {
  eventoEditar.value = { ...evento.value };
  modalEditar.value = true;
}

function cerrarEditar() {
  modalEditar.value = false;
  eventoEditar.value = null;
}

async function guardar() {
  guardando.value = true;
  try {
    evento.value = await editarEventoDashboard(eventoEditar.value.id, eventoEditar.value);
    Swal.fire({
      icon: "success",
      title: "Guardado",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      background: "#0f1520",
      color: "#fff",
    });
    cerrarEditar();
  } catch (e) {
    const msg = e.response?.data ? JSON.stringify(e.response.data) : "Error al guardar.";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: msg,
      background: "#0f1520",
      color: "#fff",
      confirmButtonColor: "#f3bc2c",
    });
  } finally {
    guardando.value = false;
  }
}

function formatFecha(f) {
  if (!f) return "—";
  const [y, m, d] = f.split("-");
  const meses = [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ];
  return `${d} ${meses[parseInt(m) - 1]} ${y}`;
}

onMounted(cargar);
</script>

<style scoped>
/* ─── Base ─── */
.crud-evento {
  background-color: #0f1520;
  min-height: 100vh;
  padding: 32px;
  font-family: "Inter", sans-serif;
  color: #fff;
}

/* ─── Header de página ─── */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}
.page-title-wrap {
  color: #f3bc2c;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}
.page-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin: 4px 0 0;
}

/* ─── Estado vacío / cargando ─── */
.estado-centro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  gap: 10px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
}
.card-vacio {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
}

/* ─── Layout general ─── */
.evento-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ─── Card cabecera ─── */
.evento-header-card {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 22px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.evento-header-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.badge-activo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(34, 197, 94, 0.12);
  color: #4ade80;
  border: 1px solid rgba(74, 222, 128, 0.25);
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 11px;
  font-weight: 600;
  width: fit-content;
}
.badge-dot {
  width: 6px;
  height: 6px;
  background: #4ade80;
  border-radius: 50%;
  animation: pulse-dot 2s infinite;
}
@keyframes pulse-dot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.evento-nombre {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #fff;
}
.evento-ubicacion {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 5px;
}
.evento-ubicacion i {
  color: #f3bc2c;
}

/* ─── Fila de cards ─── */
.cards-row {
  display: grid;
  grid-template-columns: 1fr 1fr 220px;
  gap: 16px;
}

/* ─── Card base ─── */
.info-card {
  background: #060d1a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.card-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #f3bc2c;
}
.card-section-title i {
  font-size: 13px;
}

/* ─── Campos dentro de card ─── */
.card-fields {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.field-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 0;
}
.field-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.05);
}
.field-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.35);
}
.field-val {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}
.field-val.accent {
  color: #f3bc2c;
  font-weight: 600;
}

/* ─── Card cupo ─── */
.cupo-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  justify-content: center;
}
.cupo-pct-big {
  font-size: 42px;
  font-weight: 800;
  line-height: 1;
  color: #fff;
}
.cupo-pct-big span {
  font-size: 22px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
}
.cupo-label-sub {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.35);
  font-weight: 600;
}
.cupo-track {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 4px;
}
.cupo-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease;
}
.cupo-verde {
  background: linear-gradient(90deg, #22c55e, #4ade80);
}
.cupo-amarillo {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
}
.cupo-rojo {
  background: linear-gradient(90deg, #ef4444, #f87171);
}

/* ─── Fila inferior ─── */
.bottom-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* ─── Card video ─── */
.video-card {
  gap: 14px;
}
.iframe-wrap {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
  border-radius: 10px;
  overflow: hidden;
  background: #000;
}
.iframe-wrap iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.video-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 140px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.25);
  font-size: 13px;
}
.video-vacio i {
  font-size: 26px;
}
.video-url-row {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.35);
  font-size: 11px;
  overflow: hidden;
}
.video-url-row i {
  flex-shrink: 0;
  color: #f3bc2c;
}
.video-url-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ─── Card descripción ─── */
.desc-card {
  gap: 14px;
}
.desc-texto {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.7;
  margin: 0;
}

/* ─── Modal ─── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.modal-panel {
  background: #0f1520;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 100%;
  max-width: 640px;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 16px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}
.modal-titulo {
  color: #f3bc2c;
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}
.form-section-label {
  grid-column: span 2;
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #f3bc2c;
  padding: 6px 0 2px;
  border-bottom: 1px solid rgba(243, 188, 44, 0.15);
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.col-span-2 {
  grid-column: span 2;
}
label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.45);
}
.input-form {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  padding: 9px 12px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s;
  width: 100%;
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
}
.input-form:focus {
  border-color: rgba(243, 188, 44, 0.5);
}
textarea.input-form {
  resize: vertical;
}

/* ─── Botones ─── */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #f3bc2c;
  color: #0f172a;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.btn-primary:hover:not(:disabled) {
  background: #e5ae24;
}
.btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.btn-secondary:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
}
.btn-icon {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.15s;
}
.btn-icon:hover {
  color: #f3bc2c;
  background: rgba(243, 188, 44, 0.1);
}

/* ─── Responsive ─── */
@media (max-width: 900px) {
  .cards-row {
    grid-template-columns: 1fr 1fr;
  }
  .info-card:last-child {
    grid-column: span 2;
  }
}
@media (max-width: 640px) {
  .crud-evento {
    padding: 16px;
  }
  .cards-row {
    grid-template-columns: 1fr;
  }
  .info-card:last-child {
    grid-column: auto;
  }
  .bottom-row {
    grid-template-columns: 1fr;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .col-span-2 {
    grid-column: auto;
  }
  .form-section-label {
    grid-column: auto;
  }
}
</style>
